import { translate } from '@teamleader/i18n';
import React, { useContext } from 'react';

import Header from '..';
import { useIsMedium } from '../../../../Components/Context/Hooks/mediaQueries';
import Box, { BoxProps } from '../../../../Components/UI/Box';
import { apiFormatDate, fromISO } from '../../../../Utils/date';
import { ProjectContext } from '../../Context';
import styles from '../styles.css';

const ProjectsHeader: React.FC<BoxProps> = ({ ...rest }) => {
  const { project, department } = useContext(ProjectContext);
  const isMedium = useIsMedium();

  return (
    <>
      <Header {...rest}>
        <Box className={styles['title-wrapper']}>
          <Box className={styles['title']}>
            <Box element="h1" display="flex" alignItems="center">
              <span className={styles['title-text']} title={project!.title}>
                {project!.title}
              </span>
            </Box>
          </Box>
        </Box>
        {isMedium && (
          <Box display="flex" alignItems="flex-start" marginVertical={3} marginLeft={3}>
            {project!.startDate && (
              <Box className={styles['data']} marginLeft={5}>
                <h4 className={styles['data-label']}>{translate('startDate')}</h4>
                <span className={styles['data-value']}>
                  {apiFormatDate(fromISO(project!.startDate), department!.dateFormat)}
                </span>
              </Box>
            )}
            {project!.endDate && (
              <Box className={styles['data']} marginLeft={5}>
                <h4 className={styles['data-label']}>{translate('endDate')}</h4>
                <span className={styles['data-value']}>
                  {apiFormatDate(fromISO(project!.endDate), department!.dateFormat)}
                </span>
              </Box>
            )}
          </Box>
        )}
      </Header>
    </>
  );
};

export default ProjectsHeader;
